module.exports = __webpack_public_path__ + "static/media/scheduler.b432d7f3.gif";